import { getTextWithSoftHyphens } from '@app/components';
import { LocationDto } from '@app/hooks';

import { MappedFacetValue, UnmappedFacetValue } from '../constants';

export const getLocationLabel = ({
  id,
  locations = [],
  labelFallback = '',
}: {
  id: string;
  locations?: LocationDto[];
  labelFallback?: string;
}) => {
  const locationLabel = locations.find(location => location.id === id);

  return (
    locationLabel?.discoveryDisplayName ?? locationLabel?.name ?? labelFallback
  );
};

export const getLocationOptions = ({
  locations = [],
  values = [],
  labelFallback = '',
  withSoftHyphens = true,
}: {
  locations?: LocationDto[];
  values?: UnmappedFacetValue[];
  labelFallback?: string;
  withSoftHyphens?: boolean;
}): MappedFacetValue[] =>
  values.map(({ id, totalRecords }) => ({
    label: withSoftHyphens
      ? getTextWithSoftHyphens(
          getLocationLabel({ id, locations, labelFallback })
        )
      : getLocationLabel({ id, locations, labelFallback }),
    value: id,
    count: totalRecords,
    id,
  }));
